'use strict';

import UserProfileOffcanvas from './components/UserProfileOffcanvas.vue';

export default class {

    constructor() {
        // Register component globaly
        Vue.component('user-profile-offcanvas', UserProfileOffcanvas);

    }
}